export const VARIANT_DEFAULT = 'default';
export const VARIANT_QUATERNARY = 'quaternary';
export const VARIANT_ERROR = 'error';

export const VARIANTS = [VARIANT_DEFAULT, VARIANT_QUATERNARY, VARIANT_ERROR];
